import React from "react";
import { Badge, Stack, Text } from "@bookingcom/bui-react";
import { useI18n, t } from "@bookingcom/lingojs-react";
import { UIOrderStatus } from "@flights/types";
import useGetUrlParams from "../../../hooks/useGetUrlParams";
import { InfoSignIcon } from "@bookingcom/bui-assets-react/streamline";

type Props = {
  status: UIOrderStatus;
  pastBooking?: boolean;
  isPaymentCollection?: boolean;
  isPendingRebook?: boolean;
};

const OrderStatus: React.FunctionComponent<Props> = (props) => {
  const { status: orderStatus, pastBooking = false, isPaymentCollection = false, isPendingRebook = false } = props;
  const i18n = useI18n();

  const { getUrlParam } = useGetUrlParams();

  let color: "constructive" | "neutral_alt" | "destructive" | "accent" = "neutral_alt";
  let status = "";

  const paymentCollectionSuccess = getUrlParam("paymentCollectionSuccess") === "1";

  if (!isPaymentCollection) {
    switch (orderStatus) {
      case "CONFIRMED":
        color = "constructive";
        status = i18n.trans(t("flights_confirmation_status_confirm"));
        break;

      case "CANCELLED":
        color = "neutral_alt";
        status = i18n.trans(t("flights_confirmation_status_cancelled"));
        break;

      case "ERROR":
        color = "destructive";
        status = i18n.trans(t("flights_confirmation_status_failed"));
        break;

      case "PRE_ORDER":
      case "PENDING":
        color = "accent";
        status = i18n.trans(t("flights_pb_confirmation_status_pending"));
        break;

      default:
        throw new Error("Invalid orderStatus");
    }
  } else if (isPaymentCollection) {
    if (paymentCollectionSuccess) {
      color = "constructive";
      status = i18n.trans(t("flights_pb_confirmation_payment_success_status"));
    } else {
      color = "destructive";
      status = i18n.trans(t("flights_pb_confirmation_payment_fail_status"));
    }
  }

  if (pastBooking) {
    color = "neutral_alt";
    status = i18n.trans(t("flights_booking_status_past"));
  }

  return (
    <Stack direction="row" alignItems="center" gap={2}>
      <Text variant="body_1" color={color}>
        {status}
      </Text>
      {isPendingRebook && (
        <Badge
          variant="callout"
          alternative
          icon={InfoSignIcon}
          text={i18n.trans(t("flights_pb_status_secondary_change_in_progress"))}
        />
      )}
    </Stack>
  );
};

export default OrderStatus;
